import { isNull, omitBy } from 'lodash';

export const createDDBItem = (data: any) => {
  return omitBy(
    {
      title: data.title,
      text: data.text,
      is_active: data.is_active,
    },
    isNull,
  );
};
